// api/apiEndpoints.js

export const API_ENDPOINTS = {
    // Travel Plans
    TRAVEL_PLANS: `/api/travel-plans`,

    // Travel Requests
    TRAVEL_REQUESTS: `/api/travel-requests`,
    TRAVEL_REQUESTS_SUPERVISOR_HOD_MATCH: `/api/travel-requests/supervisor-hod-match`,
    // Travel Acquitals api/acquittals/approvals
    TRAVEL_ACQUITALS: `/api/acquittals`,
    // TRAVEL_LINE_ACTIVITIES
    TRAVEL_LINE_ACTIVITIES: `/api/travel-request-line-activities`,

    // Authentication
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: '/auth/verify-email',
    REFRESH_TOKEN: '/auth/refresh-token',

    // User
    UPDATE_PROFILE: '/users/profile',
    ROLES: '/api/my/roles',

    // Terminology Endpoints
    TRAVEL_BATCH_REQUESTS: '/api/travel-batch-request',
    SITES: '/api/site',
    PROVINCES: '/api/province',
    PROJECT_CODES: '/api/project-code',
    BRANCH_CODES: '/api/branch-code',
    ORGANIZATIONS: '/api/organisations',
    DISTRICTS: '/api/district',
    BUDGET_LINES: 'api/budget-line',
    DEPARTMENTS: '/api/departments',
    JOBTITLES: '/api/job-titles',
    USERS: '/api/users',

    // activity stream line
    NOTIFICATIONS: `/api/notifications`,
    DOCUMENTS: '/api/documents',
    ACQUITTAL_DOCUMENTS: '/api/acquittals/:id/documents',

    // reports
    REPORTS: `/api/report`,

    // Banks
    BANKS: '/api/bank',
    APPROVERS: '/api/approvers',

    VENUES: '/api/venue'
};
